import { createReducer } from 'typesafe-actions';
import { signInActions } from '~/features/auth/store/actions';

export class State {}

export const reducer = createReducer(new State()).handleAction(signInActions.success, (state, { payload }) => ({
    ...state,
}));
